import { Controller } from '@hotwired/stimulus';
import { AVCrypto } from '@assemblyvoting/av-crypto';

// Connects to data-controller="election-committee-member-keys"
export default class extends Controller {
  declare passwordFieldTarget: HTMLInputElement;
  declare signatureFieldTarget: HTMLInputElement;
  declare publicKeyFieldTarget: HTMLInputElement;
  static targets = [
    "passwordField",
    "signatureField",
    "publicKeyField",
  ]

  static values = {
    salt: String,
    curveName: String,
    latestAddress: String,
  }
  declare saltValue: string;
  declare curveNameValue: string;
  declare latestAddressValue: string;

  connect() {
    this.element.addEventListener("submit", (event: Event) => this.onSubmit(event as SubmitEvent));
  }

  onSubmit(_event: SubmitEvent) {
    const password = this.passwordFieldTarget.value;
    this.passwordFieldTarget.disabled = true;

    const crypto = new AVCrypto(this.curveNameValue);
    const { privateKey, publicKey } = crypto.generateProofOfElectionCodes([`${this.saltValue}${password}`]);

    this.signatureFieldTarget.value = crypto.sign(this.latestAddressValue, privateKey);
    this.publicKeyFieldTarget.value = publicKey;
  }
}